import { Assignee, AssigneeType } from 'api/clients/PropertyClient'
import { useWorkflow } from 'screens/ArticleViewWrapper/components/WorkflowProvider/WorkflowProvider'
import { ArticleWorkflowPropertyValue } from './ArticleWorkflowPropertyValue'
import { ProjectWorkflowPropertyValue } from './ProjectWorkflowPropertyValue'
import { ErrorBoundary } from '@sentry/react'

interface Props {
  assignee: Assignee
}

const WorkflowPropertyValue = ({ assignee }: Props) => {
  const { property, workflow, enabled, folder } = useWorkflow()

  if (!workflow || !enabled || !property || !folder) {
    return null
  }

  if (assignee.type === AssigneeType.Article) {
    return (
      <ArticleWorkflowPropertyValue articleId={assignee.id} property={property} workflow={workflow} folder={folder} />
    )
  }

  if (assignee.type === AssigneeType.Project) {
    return (
      <ProjectWorkflowPropertyValue projectId={assignee.id} folder={folder} property={property} workflow={workflow} />
    )
  }

  return null
}

const WorkflowPropertyValueContainer = (props: Props) => (
  <ErrorBoundary>
    <WorkflowPropertyValue {...props} />
  </ErrorBoundary>
)

export { WorkflowPropertyValueContainer as WorkflowPropertyValue }
